import { No_Image } from '../../Universal/Assets';

const ImageNotAvailable = () => {
  return <img src={No_Image} alt="ImageNotAvailable" loading="lazy" />;
};

export default ImageNotAvailable;
